import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { cn } from '../../common/utils';
import { sidebarStateByType } from '../../store/sidebar.state';

export const ScheduleCostControlsToggle: React.FC = () => {
  const { t } = useTranslation('simulation');

  const [sidebarState, setSidebarState] = useRecoilState(
    sidebarStateByType('sidebar-simulation-schedule-docks-controls'),
  );

  const showSidebarControls = !sidebarState.isHidden;

  return (
    <span
      className={cn(
        'p-1',
        'text-menu-text/60 cursor-pointer text-sm hover:underline',
      )}
      onClick={() => {
        setSidebarState(current => ({
          ...current,
          isCollapsed: !current.isCollapsed,
          isHidden: !current.isHidden,
        }));
      }}
    >
      {showSidebarControls ? t`Hide cost controls` : t`Show cost controls`}
    </span>
  );
};
